module.exports = __webpack_public_path__ + "img/pic_jieshao@2x.82046494.png";